import augmentor from "./augmentorP.png";

export const RED_RIGHT_HAND_PORTRAIT_IMAGES_POST = [augmentor];
